// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"29d87d7b","839":"663eeee6"}[chunkId] + ".chunk.js";
};